var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.7C2 3.65655 3.65655 2 5.7 2H8.85C9.40228 2 9.85 2.44772 9.85 3C9.85 3.55228 9.40228 4 8.85 4H5.7C4.76112 4 4 4.76112 4 5.7V8.85C4 9.40228 3.55228 9.85 3 9.85C2.44772 9.85 2 9.40228 2 8.85V5.7ZM14.15 3C14.15 2.44772 14.5977 2 15.15 2H18.3C20.3435 2 22 3.65655 22 5.7V8.85C22 9.40228 21.5523 9.85 21 9.85C20.4477 9.85 20 9.40228 20 8.85V5.7C20 4.76112 19.2389 4 18.3 4H15.15C14.5977 4 14.15 3.55228 14.15 3ZM3 14.15C2.44772 14.15 2 14.5977 2 15.15V18.3C2 20.3435 3.65655 22 5.7 22H8.85C9.40228 22 9.85 21.5523 9.85 21C9.85 20.4477 9.40228 20 8.85 20H5.7C4.76112 20 4 19.2389 4 18.3V15.15C4 14.5977 3.55228 14.15 3 14.15ZM21 14.15C21.5523 14.15 22 14.5977 22 15.15V18.3C22 20.3435 20.3435 22 18.3 22H15.15C14.5977 22 14.15 21.5523 14.15 21C14.15 20.4477 14.5977 20 15.15 20H18.3C19.2389 20 20 19.2389 20 18.3V15.15C20 14.5977 20.4477 14.15 21 14.15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameExpand);
export default __webpack_public_path__ + "static/media/frame-expand.fec3b45dcf9c64a23252adbd2d3d6543.svg";
export { ForwardRef as ReactComponent };